var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "search-result-header-tools" },
    [
      _c("search-list-upload"),
      _vm._v(" "),
      _c(
        "li",
        {
          staticClass: "search-export-xls",
          attrs: { title: "Выбрать поля и скачать список" },
        },
        [
          _c("i", {
            staticClass: "lnr lnr-download",
            on: { click: _vm.showExport },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        { staticClass: "search-print", attrs: { title: "Распечатать список" } },
        [_c("i", { staticClass: "lnr lnr-printer", on: { click: _vm.print } })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }